<template>
	<section>
		<tabs-component v-if="$route.name === 'dashboard-sales'" :tabs="tabs"></tabs-component>
		<v-layout row wrap>
			<v-select class="sucursal-select" v-bind:items="items" v-model="e1" label="Sucursal" single-line bottom></v-select>
			<v-select class="building-select" v-bind:items="buildings" v-model="e2" label="Edificio" single-line bottom></v-select>
			<v-select class="rooms-select" v-bind:items="rooms" v-model="e3" label="Todas las habitaciones" single-line bottom></v-select>
		</v-layout>
		<v-layout row wrap>
			<v-flex md5>
				<v-select class="start-date-select" v-bind:items="startDate" v-model="e4" label="16 de octubre, 2016" single-line bottom></v-select>
				<v-select class="finish-date-select" v-bind:items="finishDate" v-model="e5" label="10 de noviembre, 2016" single-line bottom></v-select>
			</v-flex>
			<v-flex md5 offset-md2>
				<button class="button-default" type="button">Año</button>
				<button class="button-default" type="button">Mes</button>
				<button class="button-default" type="button">Semana</button>
				<button class="button-default" type="button">Día</button>
			</v-flex>
		</v-layout>
		<v-layout row class="divider-rows">
			<v-flex md6 class="divider1">
				<v-layout row class="room-filters">
					<h5 class="little-subtitle-default">Habitaciones</h5>
					<v-select class="general-select" v-bind:items="general" v-model="e6" label="General" single-line bottom></v-select>
					<v-select class="status-select" v-bind:items="statusType" v-model="e7" label="Tipos de estado" single-line bottom></v-select>
					<button>Editar</button>
				</v-layout>
				<v-layout row wrap class="text-xs-left" v-for="state in states" :key="state.id">
					<v-flex md12>
						<div class="label-status">
							<h5>{{ state.name }}</h5>
							<h5>{{ state.rooms.length }} habitaciones</h5>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex md6 class="divider2">
				<v-layout row>
					<h5 class="little-subtitle-default">Estados</h5>
				</v-layout>
				<v-layout row class="big">
					<div>
						<div class="big-yellow">
							<p>15</p>
						</div>
						<label>En turno de baño o break</label>
					</div>
					<div>
						<div class="big-red">
							<p>03</p>
						</div>
						<label>Bajo rendimiento</label>
					</div>
					<div>
						<div class="big-green">
							<p>05</p>
						</div>
						<label>Alto rendimiento</label>
					</div>
				</v-layout>
				<v-layout row>
					<h5 class="little-subtitle-default">Mucamas</h5>
				</v-layout>
				<v-layout row>
					<div class="label-status mb-0">
						<h5>Nombre</h5>
						<h5>Habitación</h5>
						<h5>Calificación</h5>
					</div>
				</v-layout>
				<v-layout row class="report-maid" v-for="maid in maidsNames" :key="maid.id">
					<v-flex md4>
						<h5>{{ maid.name }}</h5>
					</v-flex>
					<v-flex md4>
						<div v-bind:class="`score-ball-${maid.qualification}`"></div>
					</v-flex>
					<v-flex md4>
						<h5>{{ maid.room }}</h5>
					</v-flex>
				</v-layout>
				<v-layout row class="alerts">
					<h5 class="little-subtitle-default">Alertas</h5>
				</v-layout>
				<v-layout row class="big b-alerts">
					<div>
						<div class="big-skyblue">
							<p>16</p>
						</div>
						<label>Objetos perdidos</label>
					</div>
					<div>
						<div class="big-red">
							<p>13</p>
						</div>
						<label>Reportar problemas</label>
					</div>
					<div>
						<div class="big-yellow">
							<p>11</p>
						</div>
						<label>Mantenimiento</label>
					</div>
				</v-layout>
				<v-layout row>
					<h5 class="little-subtitle-default">Actividades - Real time</h5>
				</v-layout>
				<v-layout row>
					<div class="realtime-content">
						<v-layout row class="realtime-item">
							<v-flex md1>
								<img src="https://randomuser.me/api/portraits/women/59.jpg" alt="">
							</v-flex>
							<v-flex md11>
								<v-layout row wrap>
									<h5>Maria Chiappe
										<span class="realtime-gray">cambió de estado</span>
										<span class="realtime-blue">En curso</span>
										<span class="realtime-gray">a</span>
										<span class="realtime-blue">Almuerzo</span>
									</h5>
								</v-layout>
								<v-layout row class="little-icon">
									<v-flex md5>
										<div class="rt-calendar-red"></div>
										<h6>
											<span class="realtime-gray">Fecha:</span> 24/03/2017</h6>
									</v-flex>
									<v-flex md5>
										<div class="rt-calendar-blue"></div>
										<h6>
											<span class="realtime-gray">Hora:</span> 09:15:24 am</h6>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
						<v-layout row class="realtime-item">
							<v-flex md1>
								<img src="https://randomuser.me/api/portraits/women/32.jpg" alt="">
							</v-flex>
							<v-flex md11>
								<v-layout row wrap>
									<h5>Almendra Gomez
										<span class="realtime-gray">terminó de limpiar la habitación</span>
										<span class="realtime-blue">5202</span>
									</h5>
								</v-layout>
								<v-layout row class="little-icon">
									<v-flex md5>
										<div class="rt-calendar-red"></div>
										<h6>
											<span class="realtime-gray">Fecha:</span> 24/03/2017</h6>
									</v-flex>
									<v-flex md5>
										<div class="rt-calendar-blue"></div>
										<h6>
											<span class="realtime-gray">Hora:</span> 09:15:24 am</h6>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
						<v-layout row class="realtime-item">
							<v-flex md1>
								<img src="https://randomuser.me/api/portraits/men/78.jpg" alt="">
							</v-flex>
							<v-flex md11>
								<v-layout row wrap>
									<h5>Giovanni Alvarado
										<span class="realtime-gray">cambió de estado</span>
										<span class="realtime-red">Ocupado sucio</span>
										<span class="realtime-gray">a</span>
										<span class="realtime-green">Vacante limpio</span>
										<span class="realtime-gray">habitación</span>
										<span class="realtime-blue">5202</span>
									</h5>
								</v-layout>
								<v-layout row class="little-icon">
									<v-flex md5>
										<div class="rt-calendar-red"></div>
										<h6>
											<span class="realtime-gray">Fecha:</span> 24/03/2017</h6>
									</v-flex>
									<v-flex md5>
										<div class="rt-calendar-blue"></div>
										<h6>
											<span class="realtime-gray">Hora:</span> 09:15:24 am</h6>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
						<v-layout row class="realtime-item">
							<v-flex md1>
								<img src="https://randomuser.me/api/portraits/women/95.jpg" alt="">
							</v-flex>
							<v-flex md11>
								<v-layout row wrap>
									<h5>Fernanda Rivera
										<span class="realtime-gray">reportó una perdida de la habitación</span>
										<span class="realtime-blue">5412</span>
									</h5>
								</v-layout>
								<v-layout row class="little-icon">
									<v-flex md5>
										<div class="rt-calendar-red"></div>
										<h6>
											<span class="realtime-gray">Fecha:</span> 24/03/2017</h6>
									</v-flex>
									<v-flex md5>
										<div class="rt-calendar-blue"></div>
										<h6>
											<span class="realtime-gray">Hora:</span> 09:15:24 am</h6>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</div>
				</v-layout>
			</v-flex>
		</v-layout>
	</section>
</template>

<script>
import RoomStatus from '@/components/shared/RoomStatus';
import TabsComponent from '@/components/shared/TabsComponent';

function mounted() {
	this.states = [
		{
			id: 1,
			name: 'Ocupado sucio',
			rooms_quantity: 5,
			rooms: [
				{
					id: 1,
					roomtype_name: 'Deluxe',
					name: 'OS',
					clean_state: 1,
				},
				{
					id: 2,
					roomtype_name: 'Suite',
					number: '5313',
					code: 'STE',
					clean_state: 1,
				},
				{
					id: 3,
					roomtype_name: 'Standard',
					number: '5314',
					code: 'STD',
					clean_state: 1,
				},
				{
					id: 4,
					roomtype_name: 'Other',
					number: '5315',
					code: 'OTH',
					clean_state: 1,
				},
				{
					id: 5,
					roomtype_name: 'Another',
					number: '5316',
					code: 'ATH',
					clean_state: 1,
				},
			],
		},
		{
			id: 2,
			name: 'Vacante sucio',
			rooms: [
				{
					id: 1,
					roomtype_name: 'Deluxe',
					number: '5412',
					code: 'DLX',
					clean_state: 2,
				},
				{
					id: 2,
					roomtype_name: 'Suite',
					number: '5413',
					code: 'DLX',
					clean_state: 2,
				},
				{
					id: 3,
					roomtype_name: 'Standard',
					number: '5414',
					code: 'DLX',
					clean_state: 2,
				},
			],
		},
		{
			id: 3,
			name: 'Turn Over',
			rooms: [
				{
					id: 1,
					roomtype_name: 'Deluxe',
					number: '5420',
					code: 'DLX',
					clean_state: 3,
				},
			],
		},
		{
			id: 4,
			name: 'Mantenimiento',
			rooms: [
				{
					id: 1,
					roomtype_name: 'Deluxe',
					number: '5421',
					code: 'DLX',
					clean_state: 4,
				},
				{
					id: 2,
					roomtype_name: 'Standard',
					number: '5427',
					code: 'STD',
					clean_state: 4,
				},
			],
		},
		{
			id: 4,
			name: 'Limpieza Profunda',
			rooms: [
				{
					id: 1,
					roomtype_name: 'Deluxe',
					number: '5423',
					code: 'DLX',
					clean_state: 5,
				},
				{
					id: 2,
					roomtype_name: 'Standard',
					number: '5424',
					code: 'STD',
					clean_state: 5,
				},
				{
					id: 3,
					roomtype_name: 'Suite',
					number: '5430',
					code: 'STE',
					clean_state: 5,
				},
				{
					id: 4,
					roomtype_name: 'Other',
					number: '5432',
					code: 'OTH',
					clean_state: 5,
				},
			],
		},
		{
			id: 5,
			name: 'Ocupado Limpio',
			rooms: [
				{
					id: 1,
					roomtype_name: 'Deluxe',
					number: '5423',
					code: 'DLX',
					clean_state: 1,
				},
				{
					id: 2,
					roomtype_name: 'Standard',
					number: '5424',
					code: 'STD',
					clean_state: 1,
				},
				{
					id: 3,
					roomtype_name: 'Suite',
					number: '5430',
					code: 'STE',
					clean_state: 1,
				},
				{
					id: 4,
					roomtype_name: 'Other',
					number: '5432',
					code: 'OTH',
					clean_state: 1,
				},
				{
					id: 5,
					roomtype_name: 'Standard',
					number: '5424',
					code: 'STD',
					clean_state: 1,
				},
				{
					id: 6,
					roomtype_name: 'Suite',
					number: '5430',
					code: 'STE',
					clean_state: 1,
				},
				{
					id: 7,
					roomtype_name: 'Other',
					number: '5432',
					code: 'OTH',
					clean_state: 1,
				},
			],
		},
		{
			id: 6,
			name: 'Vacante Limpio',
			rooms: [
				{
					id: 1,
					roomtype_name: 'Deluxe',
					number: '5423',
					code: 'DLX',
					clean_state: 2,
				},
				{
					id: 2,
					roomtype_name: 'Standard',
					number: '5424',
					code: 'STD',
					clean_state: 2,
				},
				{
					id: 3,
					roomtype_name: 'Suite',
					number: '5430',
					code: 'STE',
					clean_state: 2,
				},
				{
					id: 4,
					roomtype_name: 'Other',
					number: '5432',
					code: 'OTH',
					clean_state: 2,
				},
			],
		},
		{
			id: 6,
			name: 'Fuera de servicio',
			rooms: [
				{
					id: 1,
					roomtype_name: 'Deluxe',
					number: '5423',
					code: 'DLX',
					clean_state: 6,
				},
				{
					id: 2,
					roomtype_name: 'Standard',
					number: '5424',
					code: 'STD',
					clean_state: 6,
				},
				{
					id: 3,
					roomtype_name: 'Suite',
					number: '5430',
					code: 'STE',
					clean_state: 6,
				},
				{
					id: 4,
					roomtype_name: 'Other',
					number: '5432',
					code: 'OTH',
					clean_state: 6,
				},
				{
					id: 5,
					roomtype_name: 'Other',
					number: '5432',
					code: 'OTH',
					clean_state: 6,
				},
			],
		},
		{
			id: 7,
			name: 'Bloqueado',
			rooms: [
				{
					id: 1,
					roomtype_name: 'Deluxe',
					number: '5423',
					code: 'DLX',
					clean_state: 7,
				},
				{
					id: 2,
					roomtype_name: 'Standard',
					number: '5424',
					code: 'STD',
					clean_state: 7,
				},
				{
					id: 3,
					roomtype_name: 'Suite',
					number: '5430',
					code: 'STE',
					clean_state: 7,
				},
			],
		},
		{
			id: 8,
			name: 'Gimnasio',
			rooms: [
				{
					id: 1,
					roomtype_name: 'Piso 8',
					number: 'Piso 8',
					code: 'G',
					clean_state: 8,
				},
			],
		},
		{
			id: 9,
			name: 'Pasadizo',
			rooms: [
				{
					id: 1,
					roomtype_name: 'Piso 1',
					number: 'Piso 1',
					code: 'P',
					clean_state: 9,
				},
				{
					id: 2,
					roomtype_name: 'Piso 2',
					number: 'Piso 2',
					code: 'P',
					clean_state: 9,
				},
				{
					id: 3,
					roomtype_name: 'Piso 3',
					number: 'Piso 3',
					code: 'P',
					clean_state: 9,
				},
				{
					id: 4,
					roomtype_name: 'Piso 4',
					number: 'Piso 4',
					code: 'P',
					clean_state: 9,
				},
			],
		},
	];
	this.maidsNames = [
		{
			id: 1,
			name: 'Maria Chiappe',
			qualification: 1,
			room: 504,
		},
		{
			id: 2,
			name: 'Maria Ramirez',
			qualification: 2,
			room: 505,
		},
		{
			id: 3,
			name: 'Maria Rodriguez',
			qualification: 3,
			room: 506,
		},
		{
			id: 1,
			name: 'Maria Chiappe',
			qualification: 1,
			room: 504,
		},
		{
			id: 2,
			name: 'Maria Ramirez',
			qualification: 2,
			room: 505,
		},
		{
			id: 3,
			name: 'Maria Rodriguez',
			qualification: 3,
			room: 506,
		},
		{
			id: 1,
			name: 'Maria Chiappe',
			qualification: 1,
			room: 504,
		},
		{
			id: 2,
			name: 'Maria Ramirez',
			qualification: 2,
			room: 505,
		},
		{
			id: 3,
			name: 'Maria Rodriguez',
			qualification: 3,
			room: 506,
		},
		{
			id: 1,
			name: 'Maria Chiappe',
			qualification: 1,
			room: 504,
		},
		{
			id: 2,
			name: 'Maria Ramirez',
			qualification: 2,
			room: 505,
		},
		{
			id: 3,
			name: 'Maria Rodriguez',
			qualification: 3,
			room: 506,
		},
		{
			id: 1,
			name: 'Maria Chiappe',
			qualification: 1,
			room: 504,
		},
		{
			id: 2,
			name: 'Maria Ramirez',
			qualification: 2,
			room: 505,
		},
		{
			id: 3,
			name: 'Maria Rodriguez',
			qualification: 3,
			room: 506,
		},
		{
			id: 1,
			name: 'Maria Chiappe',
			qualification: 1,
			room: 504,
		},
		{
			id: 2,
			name: 'Maria Ramirez',
			qualification: 2,
			room: 505,
		},
		{
			id: 3,
			name: 'Maria Rodriguez',
			qualification: 3,
			room: 506,
		},
		{
			id: 1,
			name: 'Maria Chiappe',
			qualification: 1,
			room: 504,
		},
		{
			id: 2,
			name: 'Maria Ramirez',
			qualification: 2,
			room: 505,
		},
	];
}

export default {
	mounted,
	components: {
		RoomStatus,
		TabsComponent,
	},
	name: 'dashboard-sales',
	data() {
		return {
			e1: null,
			e2: null,
			e3: null,
			e4: null,
			e5: null,
			e6: null,
			e7: null,
			items: [
				{ text: 'Sucursal 1' },
				{ text: 'Sucursal 2' },
				{ text: 'Sucursal 3' },
				{ text: 'Sucursal 4' },
			],
			buildings: [
				{ text: 'Building 1' },
				{ text: 'Building 2' },
				{ text: 'Building 3' },
				{ text: 'Building 4' },
			],
			rooms: [
				{ text: 'Room 1' },
				{ text: 'Room 2' },
				{ text: 'Room 3' },
				{ text: 'Room 4' },
			],
			startDate: [
				{ text: 'Start Date 1' },
				{ text: 'Start Date 2' },
				{ text: 'Start Date 3' },
				{ text: 'Start Date 4' },
			],
			finishDate: [
				{ text: 'Finish Date 1' },
				{ text: 'Finish Date 2' },
				{ text: 'Finish Date 3' },
				{ text: 'Finish Date 4' },
			],
			general: [
				{ text: 'General 1' },
				{ text: 'General 2' },
				{ text: 'General 3' },
				{ text: 'General 4' },
			],
			statusType: [
				{ text: 'Status 1' },
				{ text: 'Status 2' },
				{ text: 'Status 3' },
				{ text: 'Status 4' },
			],
			states: [],
			maidsNames: [],
			tabs: [
				{
					id: 1,
					title: 'Trabajadores',
					link: '/dashboard',
				},
				{
					id: 2,
					title: 'Ventas',
					link: '/dashboard/sales',
				},
			],
		};
	},
};
</script>

<style lang="scss" scoped>
section {
	background-color: map-get($colors, default-bg);
	padding: 14px 14px 20px;
}

.start-date-select label {
	margin: -14px 0px 0px 25%;
}

.flex .input-group {
	float: left;
}

.flex .button-default {
	float: right;
}

.button-default {
	margin-bottom: 12px;
	margin-top: 0;
}

.label-status {
	background-color: map-get($colors, bg-subtitle);
	flex: none;
	height: 26px;
	margin-bottom: 15px;
	padding: 0 20px 0 11px;
	width: 100%;
}

.label-status h5 {
	color: map-get($colors, default-label);
	display: inline-flex;
	font-size: map-get($sizes, twelve);
	margin: -2px 0 0 0;
}

.label-status h5:first-child {
	float: left;
}

.label-status h5:nth-child(2) {
	float: right;
}

.divider-rows .divider1 {
	border-right: 1px solid map-get($colors, e-bg-icon);
	padding-right: 1%;
}

.divider-rows .divider2 {
	padding-left: 1%;
}

.divider-rows .divider2 .alerts {
	border-top: 1px solid map-get($colors, e-bg-icon);
	margin-left: -2%;
	margin-top: 2%;
	padding-left: 2%;
	width: 101%;
}

.divider-rows .divider2>.layout:first-child {
	height: 29px;
}

.divider-rows .divider2>.layout:nth-child(3) h5 {
	margin-bottom: 0;
	margin-top: 16px;
}

.divider-rows .divider2 .b-alerts {
	border-bottom: 1px solid map-get($colors, e-bg-icon);
	margin-left: -2%;
	padding-bottom: 4%;
	padding-left: 2%;
}

section .layout.row.wrap:nth-child(2) {
	border-bottom: 1px solid map-get($colors, e-bg-icon);
}

.big-yellow {
	@include realtime-bignumbers(map-get($colors, default-yellow));
}

.big-red {
	@include realtime-bignumbers(map-get($colors, default-red));
}

.big-green {
	@include realtime-bignumbers(map-get($colors, default-green));
}

.big-skyblue {
	@include realtime-bignumbers(map-get($colors, default-skyblue));
}

.big p {
	font-size: 48px;
	margin: 5px;
}

.big label {
	color: map-get($colors, default-label);
	font-size: map-get($sizes, twelve);
}

.big {
	justify-content: center;
}

.report-maid {
	padding: 0 20px 0 10px;
	border-bottom: 1px solid transparent;
}

.report-maid:hover {
	border-bottom: 1px solid map-get($colors, default-skyblue);
	font-family: 'San Francisco Display Medium';
	font-weight: map-get($weights, w-six);
	cursor: pointer;
}

.report-maid h5 {
	color: #000;
	font-size: 14px;
	margin: 0;
}

.report-maid .flex:first-child h5 {
	float: left;
}

.report-maid .flex:nth-child(3) h5 {
	float: right;
}

.realtime-content {
	background-color: white;
	margin-bottom: 28px;
	margin-left: 8px;
	padding: 14px 10px;
}

.realtime-content .realtime-item {
	border-bottom: 1px solid map-get($colors, e-bg-icon);
	height: fit-content;
	margin-bottom: 12.5px;
	text-align: left;
}

.realtime-content .realtime-item img {
	border-radius: 50px;
	height: 46px;
	width: 46px;
}

.realtime-content .realtime-item .flex.md11 {
	padding-left: 20px;
}

.realtime-content .realtime-item h5 {
	font-size: map-get($sizes, fourteen);
	line-height: 18px;
	margin-bottom: 11px;
}

.realtime-content .realtime-item h6 {
	font-size: map-get($sizes, twelve);
}

.score-ball-3 {
	@include score-ball(map-get($colors, default-red));
}

.score-ball-1 {
	@include score-ball(map-get($colors, default-green));
}

.score-ball-2 {
	@include score-ball(map-get($colors, default-yellow));
}

.realtime-gray {
	color: map-get($colors, realtime-label);
}

.realtime-blue {
	color: map-get($colors, default-skyblue);
}

.realtime-red {
	color: map-get($colors, default-red);
}

.realtime-green {
	color: map-get($colors, default-green);
}

.rt-calendar-red {
	@include default-little-icon(map-get($colors, default-red), url(../../static/img/sprites/spritesheet-icons.png), -26px -1px);
}

.rt-calendar-blue {
	@include default-little-icon(map-get($colors, default-skyblue), url(../../static/img/sprites/spritesheet-icons.png), -38px -23px);
}

.realtime-content .little-icon .md5 {
	display: inline-flex;
}
</style>




// WEBPACK FOOTER //
// DashboardSales.vue?0ce12a98